// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingConsultPanel_root__tkaHa","form":"EditListingConsultPanel_form__1-Qc-","title":"EditListingConsultPanel_title__c3cXV"};